<template>
  <div>
    <label
      v-if="titulo != 'hide'"
      v-bind:class="{
        'text-danger': current.errors && current.errors.tienda,
      }"
      >{{ titulo }}</label
    >
    <select
      v-bind:class="_class"
      style="width: 100%"
      autofocus="autofocus"
      required
      v-model="current.tienda"
      :disabled="isdisabled || disabled"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    >
      <option v-if="incluir_en_blanco" value="null">Elije una tienda</option>
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option
        v-for="(tienda, key) in tiendas"
        :value="tienda.codigo"
        :key="key"
      >
        {{ tienda.codigo }} - {{ tienda.nombre }}
      </option>
    </select>
    <small
      v-if="current.errors && current.errors.tienda"
      class="form-text text-danger"
      >{{ current.errors.tienda[0] }}</small
    >
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    desblock: {
      type: Boolean,
      required: false,
    },
    titulo: {
      type: String,
      default: "Tienda",
    },
    _class: {
      type: String,
      default: "form-control",
    },
    incluir_en_blanco: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    isdisabled: function () {
      let self = this;
      if (self.desblock == true) {
        return false;
      }
      if (self.current.estado != undefined) {
        return self.current.estado != "A";
      }
      return false;
    },
  },
  mounted() {
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    let self = this;
    if (self.current.estado == undefined) {
      self.current.estado = "A";
    }
  },
};
</script>
